import React from 'react'
import styled from 'styled-components'

import CMS from '@talus-analytics/library.airtable-cms'
import useIndexPageData from '../../../../cmsHooks/useIndexPageData'

import { Subheader } from '../../../ui'
import device from '../../../../utilities/device'

const Container = styled.div`
  margin-top: 50px;
  @media ${device.mobileL} {
    margin-top: 30px;
  }
`
const ReasonDescrip = styled.p`
  margin-top: 15px;
  font-size: 22px;
  line-height: 1.4em;
`
interface ReasonProps {
  number: number
  className?: any
}
const Reason = ({ number, className }: ReasonProps): JSX.Element => {
  const data = useIndexPageData()

  return (
    <Container className={className}>
      <Subheader lightBlue>
        <CMS.Text name={`Why ${number} tagline`} data={data} />
      </Subheader>
      <ReasonDescrip>
        <CMS.Text name={`Why ${number} description`} data={data} />
      </ReasonDescrip>
    </Container>
  )
}

export default Reason
